module.exports = __webpack_public_path__ + "img/dbhb.9c128dd8.png";